export default "<ion-app [dir]=\"rtlSide\">\n    <ion-router-outlet></ion-router-outlet>\n</ion-app>";